import {
    Component,
    Input,
    OnInit,
    EventEmitter,
    Output,
    OnChanges,
    SimpleChanges,
    OnDestroy, effect} from '@angular/core';
import { FormGroup, Validators } from '@angular/forms';
import { MatDialog } from '@angular/material/dialog';
import { ActivatedRoute } from '@angular/router';
import { HelperService, IdentifierService } from 'merlin-core';
import { ToastrService } from 'ngx-toastr';
import { ActionError } from 'projects/clinician/src/app/my-account/services/my-account.model';
import { LocalizationService } from 'src/core/utilitites/localization.service';
import { PatientTransferRequestClinicService } from '../../../services/patient-transfer-request-clinic.service';
import { EmergencyContactPopup } from './emergency-contact-popup/emergency-contact-popup.component';
import { LookupService } from '../../../../clinic-admin/services/lookup.service';
import { EnrollPatientDeviceDataService } from '../../../services/enroll-patient-device-data.service';
import { CountryCdEnum, PopupService, PopupType } from 'merlin-library';
import { FunctionMode } from '../../enums/enroll-patient.enum';
import { debounceTime, distinctUntilChanged, take } from 'rxjs/operators';
import { Subscription } from 'rxjs';
import { CommonService } from 'projects/clinician/src/app/shared/service/common.service';
import { AVEIR_ALL_CODES } from '../device-transmit-information/device-codes.constants';
@Component({
    selector: 'app-address-contact-information',
    templateUrl: './address-and-contact-information.component.html',
    styleUrls: ['./address-and-contact-information.component.scss'],
    standalone: false
})
export class AddressContactInformationComponent implements OnInit, OnChanges, OnDestroy {
    private readonly aveirLpCodes = new Set(AVEIR_ALL_CODES);
    public phoneForm: FormGroup;
    public patientDetails: FormGroup;
    private isEmergencyAddressOpen = false;
    public isPhoneEmpty = true;
    public isAreaCdEmpty = true;
    public isCountryCdEmpty = true;
    public isEmailReq = true;
    requiredPhoneForDirMethod: boolean = false;
    public transmitterOrderFlg: boolean = false;
    public directCallPhone = false;
    public emerShowPhysicianOpt: boolean = false;
    public isAddressFieldRequired: boolean = false;
    errorMsgs = [];
    isSelectedUSACountry: boolean;
    private countryLocationCd = '';
    countryList: any;
    emergencyContactSubscription: Subscription;
    isDataCorrected: boolean = false;
    defaultDirCallMethod: any;
    isIcmSelected: boolean = false;

    // @Output() public handleEmailPhone: EventEmitter<any> = new EventEmitter<any>();
    @Input() functionMode: string;
    @Input() displayMode: string;
    @Input() patRes: any;
    @Input() public patientDeviceForm: FormGroup;
    @Input() public dropDownsList;
    @Input() public showPhysicianOpt = false;
    @Input() public showAddrValidations = false;
    @Input() public phoneValidations = false;
    @Input() public toggleEmergencyCont = false;
    @Input() public emailValidations = false;
    @Input() public isNGQCategory;
    @Input() public isICMCategory;
    @Input() public isLPCategory;
    @Input() public countryCd;
    @Output() public handleEmergencyCont: EventEmitter<any> =
        new EventEmitter<any>();
    @Output() public handleEmailPhone: EventEmitter<any> =
        new EventEmitter<any>();
    @Input() public addressDetails: FormGroup;

    public stringLabels = [
        "label.gb.address_contact",
        "label.gb.emergency_contact",
        "label.gb.address1",
        "label.gb.city",
        "label.gb.country",
        "label.gb.address2",
        "label.gb.state_province",
        "label.gb.address3",
        "label.gb.zip_post_code",
        "label.gb.primary_phone",
        "label.gb.phone_country_code",
        "label.gb.phone_area_code",
        "label.gb.phone_number",
        "label.gb.email"
    ]

    public labels: Record<string, string>;

    constructor(
        public dialog: MatDialog,
        public identifierService: IdentifierService,
        private enrollDeviceDataService: EnrollPatientDeviceDataService,
        private route: ActivatedRoute,
        private requestService: PatientTransferRequestClinicService,
        private helperService: HelperService,
        private localizationService: LocalizationService,
        private toasterService: ToastrService,
        private lookupSer: LookupService,
        public deviceDataService: EnrollPatientDeviceDataService,
        public popupService: PopupService,
        public commonService: CommonService
    ) {
        effect(() => {
            const lang = this.localizationService.currentLang();
            if (!lang) return;
            this.labels = this.localizationService.reparseLocalizedStrings(this.labels);
        });
    }

    ngOnChanges(changes: SimpleChanges) {
        let country = this.addressDetails?.get('countryCd').value;
        this.transmitterOrderFlg = this.patientDeviceForm?.get('deviceData')?.get('transmitter')?.value;
        this.isSelectedUSACountry = country == CountryCdEnum.USA;
        // if(this.isICMCategory || this.isNGQCategory) {
        //     this.showPhysicianOpt = false;
        // }
        if(this.isICMCategory || this.isNGQCategory ||this.isAveirDevice() ) {
            this.emerShowPhysicianOpt = false;
        } else {
            this.emerShowPhysicianOpt = true;
        }
        this.updateStateValidators();
        if (changes.showAddrValidations || changes.isLPCategory || changes.isICMCategory || changes.isNGQCategory) {
            this.updateValidations(country);
        }
        this.countryList = this.sortCountryObjects(
            this.dropDownsList.countryCodes
        );
    }

    ngOnInit() {
        this.translateStrings();
        // this.phoneMandatoryField();
        this.phoneForm = this.patientDeviceForm
            ?.get('patientDetails')
            ?.get('phone') as FormGroup;
        this.patientDetails = this.patientDeviceForm?.get(
            'patientDetails'
        ) as FormGroup;
        this.patientDetails
            ?.get('email')
            .valueChanges.pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((res) => {
                this.handleEmailPhone.emit(res);
            });
        this.phoneForm
            ?.get('phoneNum')
            .valueChanges.pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((change) => {
                this.handleEmailPhone.emit(change);
            });
        this.phoneForm
            ?.get('areaCode')
            .valueChanges.pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((change) => {
                this.handleEmailPhone.emit(change);
            });
        this.phoneForm
            ?.get('countryCode')
            .valueChanges.pipe(debounceTime(1000), distinctUntilChanged())
            .subscribe((change) => {
                this.handleEmailPhone.emit(change);
            });
        if (!this.phoneForm?.get('phoneNum'))
            //phone num check
            this.isPhoneEmpty = true;
        else this.isPhoneEmpty = false;
        if (!this.phoneForm?.get('areaCode'))
            //area code check
            this.isAreaCdEmpty = true;
        else this.isAreaCdEmpty = false;
        if (!this.phoneForm?.get('countryCode'))
            //country code check
            this.isCountryCdEmpty = true;
        else this.isCountryCdEmpty = false;
        if (this.isPhoneEmpty || this.isAreaCdEmpty || this.isCountryCdEmpty)
            this.isEmailReq = true;
        else this.isEmailReq = false;
        this.bindFieldsData();

        this.addressDetails
            .get('countryCd')
            .valueChanges.subscribe((country) => {
                this.isSelectedUSACountry = country == CountryCdEnum.USA;
            });
        this.onSelectDirectCallMethod();
        // this.deviceDataService.showEmergencyContactPopup.subscribe((res) => {
        //     this.deviceDataService.patientId.subscribe((patientID)=> {
        //         if (patientID) {
        //                 if (res && this.toggleEmergencyCont) {
        //                     if (!this.isEmergencyAddressOpen) {
        //                         const dialogRef = this.dialog.open(EmergencyContactPopup, {
        //                             width: '500px',
        //                             disableClose: true,
        //                             data: {
        //                                 mode: this.displayMode,
        //                                 showPhysicianOpt: this.showPhysicianOpt,
        //                                 functionMode: this.functionMode,
        //                                 countryCd: this.countryCd,
        //                             },
        //                         });
        //                         dialogRef.afterClosed().subscribe((result) => {
        //                             this.isEmergencyAddressOpen = false;
        //                             this.toggleEmergencyCont = false;
        //                             this.handleEmergencyCont.emit(false);
        //                         });
        //                         this.isEmergencyAddressOpen = true;
        //                     }
        //                 } else {
        //                     this.toggleEmergencyCont = false;
        //                 }
        //         }
        //     });
        // });

        this.emergencyContactSubscription = this.deviceDataService.openEmergencyContact$.subscribe(
            (response: boolean)=>{
                if(response){
                    this.getEmergencyPOP();
                }
            }
        )
        this.deviceDataService.getDefaultDirCallMethod().subscribe((callMethod)=>{this.defaultDirCallMethod = callMethod
       })
        this.patientDeviceForm?.get('deviceData')?.get('transmitter')?.valueChanges.subscribe((transmitterValue) => {
            this.transmitterOrderFlg = transmitterValue;
            let country = this.addressDetails?.get('countryCd').value;
            this.updateValidations(country);
        });
    }

    ngOnDestroy(): void {
        this.emergencyContactSubscription?.unsubscribe();
    }

    getPhoneInfo(value) {
        if (value) {
            return value.toString().length > 3
                ? value.toString().substring(0, 3) +
                      ' ' +
                      value
                          .toString()
                          .slice(3)
                          .match(/\d{1,4}/g)
                          .join(' ')
                : value;
        }
        return value;
    }

    translateStrings(){
        this.labels = this.localizationService.appendStringLabelsToRecord(this.labels, this.stringLabels);
    }

    phoneNoChange($event) {
        if ($event.target.value == '') this.isPhoneEmpty = true;
        else this.isPhoneEmpty = false;
        if (this.isPhoneEmpty || this.isAreaCdEmpty || this.isCountryCdEmpty)
            this.isEmailReq = true;
        else this.isEmailReq = false;
    }

    areaCodeChange($event) {
        if ($event.target.value == '') this.isAreaCdEmpty = true;
        else this.isAreaCdEmpty = false;
        if (this.isPhoneEmpty || this.isAreaCdEmpty || this.isCountryCdEmpty)
            this.isEmailReq = true;
        else this.isEmailReq = false;
    }

    countryCodeNoChange($event) {
        if ($event.target.value == '') this.isCountryCdEmpty = true;
        else this.isCountryCdEmpty = false;
        if (this.isPhoneEmpty || this.isAreaCdEmpty || this.isCountryCdEmpty)
            this.isEmailReq = true;
        else this.isEmailReq = false;
    }

    bindFieldsData() {
        this.route.params.subscribe((res) => {
            if (res?.id) {
                this.requestService.getPatientProfile().subscribe(
                    (data) => {
                        if (data?.patient?.address) {
                            this.addressDetails
                                .get('address')
                                .patchValue(data.patient.address?.address);
                            this.addressDetails
                                .get('stateCd')
                                .patchValue(data.patient.address?.stateCd);
                            this.addressDetails
                                .get('address2')
                                .patchValue(data.patient.address?.address2);
                            this.addressDetails
                                .get('zipCode')
                                .patchValue(data.patient.address?.zipCode);
                            this.addressDetails
                                .get('address3')
                                .patchValue(data.patient.address?.address3);
                            this.addressDetails
                                .get('countryCd')
                                .patchValue(data.patient.address?.countryCd);
                            this.countryLocationCd =
                                data.patient.address?.countryCd;
                            this.addressDetails
                                .get('city')
                                .patchValue(data.patient.address?.city);
                            this.addressDetails
                                .get('state')
                                .patchValue(data.patient.address?.state);
                        }
                        if (data?.patient?.email) {
                            this.patientDetails
                                .get('email')
                                .patchValue(data.patient.email);
                        }
                        const phoneGrp = this.phoneForm;
                        if (data?.patient?.phone?.countryCode) {
                            phoneGrp
                                .get('countryCode')
                                .patchValue(data.patient.phone?.countryCode);
                        }
                        if (data?.patient?.phone?.areaCode) {
                            phoneGrp
                                .get('areaCode')
                                .patchValue(data.patient.phone?.areaCode);
                        }
                        if (data?.patient?.phone?.phoneNum) {
                            phoneGrp
                                .get('phoneNum')
                                .patchValue(data.patient.phone?.phoneNum);
                        }
                    },
                    (err) => {
                        if (err && err.actionErrors) {
                            this.showToaster(err.actionErrors);
                        } else {
                            this.helperService.showErrorToastr(err);
                        }
                    }
                );
            }
        });
    }

    sortCountryObjects(list) {
        this.countryList = this.dropDownsList.countryCodes;
        let countryList = list?.map((country) => {
            let rc = this.formatDDString(country);
            return {
                ...country,
                label: rc,
            };
        });


        return countryList?.sort((a, b) => {
            const nameA = this.localizationService.generateLocalizedStr(
                a.label
            );
            const nameB = this.localizationService.generateLocalizedStr(
                b.label
            );
            if (nameA < nameB) {
                return -1;
            }
            if (nameA > nameB) {
                return 1;
            }

            return 0;
        });
    }
    // phoneMandatoryField () {
    //     if(this.isICMCategory || this.isNGQCategory) {
    //         this.requiredPhoneForDirMethod  = false;
    //         this.defaultDirCallMethod = false;
    //     }
    // }
    onChangeCountry(value) {
        let country = this.addressDetails?.get('countryCd').value;
        this.isSelectedUSACountry = country == CountryCdEnum.USA;
        this.enrollDeviceDataService.addresscountryUs.next(this.isSelectedUSACountry)
        this.updateValidations(value);
        // if ([null, '',undefined].includes(this.phoneForm.get('phoneNum').value)) {
            this.lookupSer.getDefaultCountryCode(country).subscribe((res) => {
                if (res) {
                    if(!(this.functionMode == 'profile' &&
                        this.displayMode == 'edit' &&  this.phoneForm?.get('areaCode').value && this.phoneForm?.get('phoneNum').value)){
                    this.phoneForm
                        .get('countryCode')
                        .setValue(res.countryCallingCode);
                    }
                }
            });
        // }
    }

    compareCountryCd(o1, o2) {
        return o1 == o2;
    }

    updateStateValidators() {
        if (this.isSelectedUSACountry) {
            //   this.addressDetails.get('state').setValue(null);
            this.addressDetails?.get('state').clearValidators();
        } else {
            //   this.addressDetails.get('stateCd').setValue(null);
            this.addressDetails?.get('stateCd').clearValidators();
        }
    }

    updateValidations(value) {
        if (!this.addressDetails) return;
        const isUSA = value == CountryCdEnum.USA;
        const transmitterOrdered = this.patientDeviceForm?.get('deviceData')?.get('transmitter')?.value ?? this.transmitterOrderFlg;
        if (isUSA) {
            if (this.isICMCategory || this.isAveirDevice() || this.isLPCategory || this.isNGQCategory) {
                this.isAddressFieldRequired = true;
            }
            else if (transmitterOrdered) {
                this.isAddressFieldRequired = true;
            }
            else {
                this.isAddressFieldRequired = false;
            }
            this.isSelectedUSACountry = true;
        } else {
            this.isAddressFieldRequired = false;
            this.isSelectedUSACountry = false;
        }
        if (this.isAddressFieldRequired) {
            this.addressDetails.get('state')?.clearValidators();
            this.addressDetails.get('address')?.setValidators([Validators.required]);
            this.addressDetails.get('stateCd')?.setValidators([Validators.required]);
            this.addressDetails.get('zipCode')?.setValidators([
                Validators.required,
                Validators.pattern(
                    new RegExp(/^([^\d]*\d){5}(-?([^\d]*\d){4})?[^\d]*$/)
                ),
            ]);
            this.addressDetails.get('city')?.setValidators([Validators.required]);
            this.addressDetails.get('countryCd')?.setValidators([Validators.required]);
        } else {
            this.addressDetails.get('stateCd')?.clearValidators();
            this.addressDetails.get('state')?.clearValidators();
            this.addressDetails.get('address')?.clearValidators();
            this.addressDetails.get('city')?.clearValidators();
            this.addressDetails.get('countryCd')?.clearValidators();
            this.addressDetails.get('zipCode')?.setValidators([Validators.pattern(new RegExp(/^[0-9]*$/))]);
        }
        this.addressDetails.get('address')?.updateValueAndValidity();
        this.addressDetails.get('stateCd')?.updateValueAndValidity();
        this.addressDetails.get('state')?.updateValueAndValidity();
        this.addressDetails.get('city')?.updateValueAndValidity();
        this.addressDetails.get('zipCode')?.updateValueAndValidity();
        this.addressDetails.get('countryCd')?.updateValueAndValidity();
    }

    log(e) {

    }
     isAveirDevice(): boolean {
        const productId = this.patRes?.patientDevices?.[0]?.productId;
        if (!productId) return false;
        const code = String(productId);
        return this.aveirLpCodes.has(code);
    }

    onEmergencyContact() {
        this.toasterService.clear();
        this.toggleEmergencyCont = true;
        this.isDataCorrected = false;
        this.commonService.setDataCorrectedValue(false);
        if (!this.displayViewUI()) {
            const msg = this.translate('msg.cm819.text');
            if (
                this.patientDeviceForm.dirty ||
                this.patientDeviceForm.invalid
            ) {
                const confirmPopup = this.generatePopUpconfig(
                    msg,
                    PopupType.Confirm
                );
                this.popupService.open(confirmPopup);
                this.popupService.confirmed().pipe(take(1)).subscribe((confirmation) => {
                    this.commonService.getDataCorrectedValue().pipe(take(1)).subscribe((val:any)=>{
                        this.isDataCorrected = val;
                        if(this.isDataCorrected){
                            this.handleEmergencyCont.emit({
                                $event: false,
                                isEmerGencyOpen: false,
                            });
                        }
                    })
                    if (confirmation) {

                        if(this.isDataCorrected){
                       setTimeout(() => {
                            this.getEmergencyPOP();
                        }, 700);
                        this.commonService.setDataCorrectedValue(false);
                        }else {
                            this.handleEmergencyCont.emit({
                                $event: true,
                                isEmerGencyOpen: true,
                            });
                        }
                    } else {
                        this.toggleEmergencyCont = false;
                        this.isDataCorrected = false;
                        this.commonService.setDataCorrectedValue(false);
                        this.handleEmergencyCont.emit({
                            $event: false,
                            isEmerGencyOpen: false,
                            cancelledUnsavePopup: true
                        });
                        return;
                    }
                });
            } else if (this.patientDeviceForm.valid) {
                setTimeout(() => {
                    this.getEmergencyPOP();
                }, 700);
            } else {
                this.handleEmergencyCont.emit({
                    $event: false,
                    isEmerGencyOpen: false,
                });
                this.isEmergencyAddressOpen = false;
                this.toggleEmergencyCont = false;
            }
        } else if (this.displayViewUI()) {
            if (this.toggleEmergencyCont && this.patientDeviceForm.valid) {
                this.isEmergencyAddressOpen = true;
                this.toggleEmergencyCont = false;
                const dialogRef = this.dialog.open(EmergencyContactPopup, {
                    width: '500px',
                    disableClose: true,
                    data: {
                        mode: FunctionMode.VIEW,
                        showPhysicianOpt: this.showPhysicianOpt,
                        functionMode: this.functionMode,
                        countryCd: this.countryCd,
                        emerShowPhysicianOpt: this.emerShowPhysicianOpt,
                    },
                });
                dialogRef.afterClosed().subscribe((result) => {
                    this.isEmergencyAddressOpen = true;
                    this.toggleEmergencyCont = false;
                    this.handleEmergencyCont.emit({
                        $event: false,
                        isEmerGencyOpen: true,
                    });
                });
            }
        }
    }

    getEmergencyPOP() {
        if (this.toggleEmergencyCont && this.patientDeviceForm.valid) {
            // this.deviceDataService.patientId.subscribe(
            //     (patientID) => {
            if (
                this.patientDeviceForm.get('patientDetails').get('patientId')
                    .value &&
                this.toggleEmergencyCont
            ) {
                this.isEmergencyAddressOpen = true;
                this.toggleEmergencyCont = false;
                const dialogRef = this.dialog.open(EmergencyContactPopup, {
                    disableClose: true,
                    width: '500px',
                    data: {
                        mode: this.functionMode,
                        showPhysicianOpt: this.showPhysicianOpt,
                        functionMode: this.functionMode,
                        countryCd: this.countryCd,
                        emerShowPhysicianOpt: this.emerShowPhysicianOpt,
                    },
                });
                dialogRef.afterClosed().subscribe((result) => {
                    this.isEmergencyAddressOpen = true;
                    this.toggleEmergencyCont = false;
                });
                // this.isEmergencyAddressOpen = true;
            }
            //  }
            //);
        }
    }

    displayEditUI() {
        if (this.functionMode == 'enroll') {
            return true;
        } else if (
            this.functionMode == 'profile' &&
            this.displayMode == 'edit'
        ) {
            return true;
        } else {
            return false;
        }
    }

    // patchCountryEditUI() {
    //     if(this.countryLocationCd) {
    //         this.addressDetails
    //                             .get('countryCd')
    //                             .patchValue(this.countryLocationCd);
    //                             this.countryLocationCd = "";

    //     }
    // }
    displayViewUI() {
        if (this.functionMode == 'profile' && this.displayMode == 'view') {
            return true;
        } else {
            return false;
        }
    }

    getState() {
        if (
            this.patRes?.patient?.address?.stateCd &&
            this.patRes?.dropdowns?.stateCodes
        ) {
            let patChamb = this.patRes.dropdowns.stateCodes.filter((code) => {
                return code.codeId == this.patRes.patient.address.stateCd;
            });
            if (!patChamb) {
                return '';
            } else {
                return this.formatDDString(patChamb[0]);
            }
        } else {
            return this.patRes?.patient?.address?.state;
        }
    }

    getCountry() {
        if (
            this.patRes?.patient?.address?.countryCd &&
            this.patRes?.dropdowns?.countryCodes
        ) {
            let patChamb = this.patRes.dropdowns.countryCodes.filter((code) => {
                return code.codeId == this.patRes.patient.address.countryCd;
            });
            if (!patChamb) {
                return '';
            } else {
                return this.formatDDString(patChamb[0]);
            }
        }
    }

    getZipCode() {
        let zipCodeVal = this.patRes?.patient?.address?.zipCode;
        let countryCd = this.patRes?.patient?.address?.countryCd;
        if (zipCodeVal) {
            if (+countryCd === CountryCdEnum.USA) {
                if (zipCodeVal.length === 9) {
                    zipCodeVal = zipCodeVal?.replace(/(\d{5})(\d{4})/, '$1-$2');
                }
                return zipCodeVal;
            } else {
                return zipCodeVal;
            }
        } else return '';
    }

    formatDDString(ddObj: any) {
        return this.localizationService.generateLocalizedStr(
            'data.Code.' + ddObj.qualifier + '.Code_Desc.' + ddObj.code
        );
    }

    showToaster(actionErrors: ActionError[]) {
        this.errorMsgs = [];
        actionErrors.forEach((item) => {
            const allKeys = Object.keys(item.parameters ?? {});
            let message = this.localizationService.generateLocalizedStr(
                item.message
            );
            allKeys.forEach((key) => {
                const param = item.parameters[key].message;
                message = message.replace(`{${key}}`, param);
            });

            this.errorMsgs.push(message);
            const errorMsg = this.helperService.getErrorList(this.errorMsgs);
            if (actionErrors.length == this.errorMsgs.length) {
                this.toasterService.error(errorMsg, null, {
                    enableHtml: true,
                    disableTimeOut: true,
                    tapToDismiss: false,
                });
            }
        });
    }

    onSelectDirectCallMethod() {
        this.deviceDataService.getPrimaryPhoneRequired().subscribe((res) => {
            if (res) {
                this.phoneForm
                    .get('countryCode')
                    .setValidators([Validators.required]);
                // this.phoneForm.get('areaCode').setValidators([Validators.required]);
                this.phoneForm
                    .get('phoneNum')
                    .setValidators([Validators.required]);
                if (this.countryCd === CountryCdEnum.USA) {
                    this.phoneForm
                        .get('areaCode')
                        .setValidators([Validators.required]);
                } else {
                    this.phoneForm.get('areaCode').clearValidators();
                    this.phoneForm.get('areaCode').updateValueAndValidity();
                }
                // Keep the pattern validator even when phone is not required,
                // so that optional entries with invalid characters are still caught.
                const phonePattern = Validators.pattern(/^[0-9\(\).,+\- ]*$/);
                this.phoneForm.get('countryCode').setValidators([phonePattern]);
                this.phoneForm.get('areaCode').setValidators([phonePattern]);
                this.phoneForm.get('phoneNum').setValidators([phonePattern]);
                this.phoneForm.updateValueAndValidity();
                this.phoneForm.markAsTouched();
                this.requiredPhoneForDirMethod = true;
                if (this.isICMCategory || this.isNGQCategory) {
                    this.emailValidations = false;
                    this.patientDetails
                        ?.get('email').clearValidators();
                    this.patientDetails
                        ?.get('email').updateValueAndValidity();
                }
                // this.phoneMandatoryField();
            } else {
                const countryCode = String(this.phoneForm?.get('countryCode')?.value ?? '').trim();
                const phoneNum = String(this.phoneForm?.get('phoneNum')?.value ?? '').trim();
                const email = String(this.patientDetails?.get('email')?.value ?? '').trim();
                const clinicCountryCd = this.addressDetails?.get('countryCd')?.value;

                if (!this.isICMCategory && !this.isNGQCategory) {
                    this.phoneValidations = false;
                } else if (this.isICMCategory && clinicCountryCd === CountryCdEnum.USA) {
                    this.phoneValidations = true;
                    this.emailValidations = false;
                } else if ((this.isICMCategory && clinicCountryCd !== CountryCdEnum.USA) || this.isNGQCategory) {
                    if (phoneNum && !email) {
                        this.emailValidations = false;
                    } else if (!phoneNum && email) {
                        this.phoneValidations = false;
                    } else if (!phoneNum && !email) {
                        this.phoneValidations = true;
                        this.emailValidations = true;
                    } else if (phoneNum && email) {
                        this.phoneValidations = false;
                        this.emailValidations = false;
                    }
                }
                // Only clear required-related errors; leave pattern errors intact.
                const ccErrors = this.phoneForm.get('countryCode').errors;
                if (ccErrors) { delete ccErrors['required']; this.phoneForm.get('countryCode').setErrors(Object.keys(ccErrors).length ? ccErrors : null); }
                const acErrors = this.phoneForm.get('areaCode').errors;
                if (acErrors) { delete acErrors['required']; this.phoneForm.get('areaCode').setErrors(Object.keys(acErrors).length ? acErrors : null); }
                const pnErrors = this.phoneForm.get('phoneNum').errors;
                if (pnErrors) { delete pnErrors['required']; this.phoneForm.get('phoneNum').setErrors(Object.keys(pnErrors).length ? pnErrors : null); }
                this.requiredPhoneForDirMethod = false;
                this.phoneForm.updateValueAndValidity();
                this.phoneForm.markAsUntouched();
                this.directCallPhone = false;
            }
        });
    }

    translate(key: string): any {
        return this.localizationService.generateLocalizedStr(key, null, 'html');
    }

    generatePopUpconfig(msgKey: string, popupType: PopupType) {
        return {
            type: popupType,
            message: this.localizationService.generateLocalizedStr(
                msgKey,
                null,
                'html'
            ),
            confirmText:
                this.localizationService.generateLocalizedStr('label.gb.ok'),
            confirmId: this.identifierService.buttonId(
                'pcs-location-popup',
                'ok'
            ),
            cancelId: this.identifierService.buttonId(
                'pcs-location-popup',
                'cancel001'
            ),
            cancelText:
                popupType == PopupType.Confirm
                    ? this.localizationService.generateLocalizedStr(
                          'label.gb.button_cancel'
                      )
                    : '',
            customPopup: true,
        };
    }
}
